import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useSpareForwardingStatus, SpareForwardingStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<SpareForwardingStatus>
    useData={useSpareForwardingStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
